import React from 'react';
import { Progress } from 'antd';
import { ArrowUp, ArrowDown, CircleCheck, TriangleAlert, CircleX, Store } from 'lucide-react';
import { StatusTag } from '../../common';
import { semantic } from '../../../theme/tokens';

/** Tienda column: name, last audit and total faces. */
export const StoreCell = ({ name, lastCheckDate, totalFaces }) => (
    <div className="py-1">
        <div className="flex items-center gap-2">
            <Store className="shrink-0 text-surface-400" />
            <span className="text-sm font-medium text-surface-900 truncate">{name}</span>
        </div>
        <div className="mt-0.5 text-xs text-surface-500">Última auditoría: {lastCheckDate || 'N/A'}</div>
        <StatusTag tone="info" className="mt-1.5 tabular-nums">
            {totalFaces || 0} caras
        </StatusTag>
    </div>
);

/** Cumplimiento General column: bar + tag (≥80 good, ≥60 attention, else low). */
export const ComplianceCell = ({ compliance }) => {
    const tone = compliance >= 80 ? 'success' : compliance >= 60 ? 'warning' : 'danger';
    const icon = compliance >= 80 ? <CircleCheck /> : compliance >= 60 ? <TriangleAlert /> : <CircleX />;
    return (
        <div className="py-1">
            <Progress percent={compliance} strokeColor={semantic[tone].solid} size="small" status="normal" showInfo={false} className="!mb-2" />
            <StatusTag tone={tone} icon={icon} className="tabular-nums">
                {compliance.toFixed(1)}%
            </StatusTag>
        </div>
    );
};

/** One category column: actual %, difference vs target, progress to target and faces. */
export const CategoryCell = ({ categoryData, targetPercentage }) => {
    if (!categoryData) {
        return <span className="text-sm text-surface-400">Sin datos</span>;
    }

    const actual = categoryData.actualPercentage;
    const diff = actual - targetPercentage;
    const isGood = diff >= 0;

    return (
        <div className="py-1">
            <div className="mb-1.5 flex items-center justify-between gap-2">
                <span className="text-sm font-semibold tabular-nums text-surface-900">{actual.toFixed(1)}%</span>
                <StatusTag tone={isGood ? 'success' : 'danger'} icon={isGood ? <ArrowUp /> : <ArrowDown />} className="tabular-nums">
                    {diff > 0 ? '+' : ''}
                    {diff.toFixed(1)}%
                </StatusTag>
            </div>
            <Progress
                percent={Math.min((actual / targetPercentage) * 100, 100)}
                strokeColor={isGood ? semantic.success.solid : semantic.danger.solid}
                size="small"
                showInfo={false}
                className="!m-0"
            />
            <div className="mt-1.5 flex justify-between text-xs text-surface-500 tabular-nums">
                <span>Meta: {targetPercentage}%</span>
                <span>{categoryData.faces} caras</span>
            </div>
        </div>
    );
};
